module.exports = __webpack_public_path__ + "media/components/weather-icon/static/dayrisksnow-26df2def2a4daeac040638df1497cec0.svg";